import Swiper from 'swiper';

export function reviews() {

    // Slider
    let sliderReviews = new Swiper('.reviews-slider', {
        containerModifierClass: 'reviews-slider',
        wrapperClass: 'reviews-slider__wrapper',
        slideClass: 'reviews-slide',
        slideActiveClass: 'is-active',
        breakpoints: {
            1319: {
                slidesPerView: 3,
                spaceBetween: 20,
            },
            999: {
                slidesPerView: 3,
                spaceBetween: 20,
            },
            767: {
                slidesPerView: 2,
                spaceBetween: 20,
            },
            320: {
                slidesPerView: 1,
                spaceBetween: 20,
                centeredSlides: true,
            },
        },
        pagination: {
            el: '.reviews-slider__pagination',
            type: 'bullets',
            bulletClass: 'reviews-slider__bullet',
            bulletActiveClass: 'reviews-slider__bullet_active',
            clickable: true,
        },
        navigation: {
            nextEl: '.reviews-button-next',
            prevEl: '.reviews-button-prev',
        },
    });

    // Подгоняем текст
    const textLength = 452;
    const textMaxLength = 510;
    const reviewsShowBtn = document.querySelectorAll('.js-reviewsShow');

    reviewsShowBtn.forEach( item => {
        let reviewsText = item.parentNode.querySelector('.js-reviewsText');

        if (reviewsText.textContent.length <= textMaxLength) {
            item.style.display = 'none';
            return false;
        }

        let currentText = reviewsText.textContent,
            textArr = currentText.split('');

        textArr.forEach( (elem, index) => {
            if (index >= textLength) {
                textArr.splice(textLength, index);
            }
        });

        let finalText = textArr.join('') + '...';

        reviewsText.textContent = finalText;

        item.addEventListener('click', () => {
            item.classList.toggle('is-active');

            if (item.classList.contains('is-active')) {
                reviewsText.textContent = currentText;
                item.textContent = 'Скрыть';
                item.closest('.reviews-slide').style.height = 'auto';
            } else {
                reviewsText.textContent = finalText;
                item.textContent = 'Читать полностью';
                item.closest('.reviews-slide').style.height = '';
            }
        });
    });

}